(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evw-product-purchase-proof"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountPurchaseProof = () => {
      const proof = document.querySelector('[data-evw-purchase-proof]');
      const actions = document.querySelector('[data-evw-concept] .evw-actions');
      if (!proof || !actions || !actions.parentNode) return;
      if (actions.nextElementSibling !== proof) actions.insertAdjacentElement('afterend', proof);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountPurchaseProof, { once: true });
    } else {
      mountPurchaseProof();
    }
    document.addEventListener('shopify:section:load', mountPurchaseProof);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-evw-about]').forEach(function (section) {
      var content = section.querySelector('.evw-about__content');
      if (!content || content.dataset.evwEnhanced === 'true') return;
      content.dataset.evwEnhanced = 'true';

      var headings = Array.prototype.slice.call(content.querySelectorAll(':scope > h2, :scope > h3'));

      headings.forEach(function (heading) {
        if (heading.textContent.trim().toLowerCase() === 'e-v-w.com') {
          heading.classList.add('evw-about__domain');
        }
      });

      var trustLink = content.querySelector('a[href*="trustpilot.com/review/e-v-w.com"]');
      if (trustLink) {
        var trustBlock = trustLink.closest('h2');
        if (trustBlock) trustBlock.classList.add('evw-about__trustpilot-block');

        var trustImage = trustLink.querySelector('img');
        if (trustImage && !trustImage.getAttribute('alt')) {
          trustImage.setAttribute('alt', 'Trustpilot');
        }
      }

      var chronoHeading = headings.find(function (heading) {
        return /chrono24 trusted seller/i.test(heading.textContent);
      });
      var chronoImage = content.querySelector('img[src*="trade_seller"]');
      var chronoUrl = 'https://www.chrono24.de/dealer/checkout-rating.htm?customerId=19889';

      if (chronoImage) {
        var imageParagraph = chronoImage.closest('p');
        var chronoLink = chronoImage.closest('a');

        if (!chronoLink) {
          chronoLink = document.createElement('a');
          chronoLink.href = chronoUrl;
          chronoImage.parentNode.insertBefore(chronoLink, chronoImage);
          chronoLink.appendChild(chronoImage);
        } else {
          chronoLink.href = chronoUrl;
        }

        chronoLink.classList.add('evw-about__chrono-card');
        if (imageParagraph) imageParagraph.classList.add('evw-about__chrono-block');

        if (!chronoImage.getAttribute('alt') && chronoHeading) {
          chronoImage.setAttribute('alt', chronoHeading.textContent.trim());
        }
      }

      if (chronoHeading) {
        chronoHeading.classList.add('evw-about__chrono-heading');
        if (!chronoHeading.querySelector('a')) {
          var headingText = chronoHeading.textContent.trim();
          chronoHeading.textContent = '';
          var headingLink = document.createElement('a');
          headingLink.href = chronoUrl;
          headingLink.textContent = headingText;
          chronoHeading.appendChild(headingLink);
        }
      }

      var investmentHeading = headings.find(function (heading) {
        return /vintage watch investment/i.test(heading.textContent);
      });
      if (investmentHeading) {
        investmentHeading.classList.add('evw-about__investment');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
